<footer>
  <div class="footer">
    <div class="container">
      <div class="footer-links__wrapper">
        <app-footer-link-columns
          *ngFor="let item of columns"
          [eventCategory]="eventCategory"
          [label]="item.label"
          [links]="item.links"
        ></app-footer-link-columns>
      </div>
      <div class="footer-socials">
        <div class="footer-socials__wrapper"></div>
        <div class="footer-arrow">
          <button (click)="scrollTop()" class="btn btn--link">
            <img src="assets/img/icons/arrow-up.svg" alt="Back to Top" />
          </button>
          <app-lang-switcher></app-lang-switcher>
        </div>
      </div>
    </div>
  </div>
  <div class="footer__lower">
    <div class="container">
      <div class="footer-copyrights">
        {{ 'FOOTER.rights' | translate }}
      </div>
      <div class="footer-copyrights__links">
        <ul class="footer-copyrights__list">
          <li class="footer-copyrights__link">
            <a [routerLink]="['/' + RoutesPath.default.terms]">
              {{ 'FOOTER.terms_conditions' | translate }}
            </a>
          </li>
          <li class="footer-copyrights__link">
            <a [routerLink]="['/' + RoutesPath.default.privacy]">
              {{ 'FOOTER.privacy_policy' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer__logos">
    <div class="bottom-logos container">
      <img src="assets/img/footer/logo_feir.webp" alt="" />
      <img src="assets/img/footer/logo_rp.webp" alt="" />
      <img src="assets/img/footer/logo_paih.webp" alt="" />
      <img src="assets/img/footer/logo_pmt.webp" alt="" />
      <img src="assets/img/footer/logo_efrr.webp" alt="" />
    </div>
  </div>
</footer>
